<form class="form-container" [formGroup]="form" style="width: 320px">
  <h2 mat-dialog-title>{{ "OTP_VERIFICATION" | translate }}</h2>

  <mat-dialog-content class="mat-typography">
    <mat-form-field appearance="outline">
      <mat-label>{{ "ENTER_OTP_FOR_VERIFICATION" | translate }} </mat-label>
      <input
        matInput
        formControlName="otp"
        placeholder="XXXXXX"
        maxlength="6"
        (input)="onOTPChange($event)"
      />
      <mat-error *ngIf="f['otp'].errors">
        <span *ngIf="f['otp'].errors['required']">{{ "OTP_REQUIRED" | translate }}</span>
        <span *ngIf="f['otp'].errors['maxlength'] || f['otp'].errors['minlength']">
          {{ "OTP_LENGTH" | translate }}
        </span>
      </mat-error>
    </mat-form-field>

    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <div>
          {{ "RESEND_REQUEST_IN" | translate }} (<span class="text-danger">{{ resendTimer + "s" }}</span>)
          <a *ngIf="retryActive" class="text-theme cursor-pointer" (click)="retry()">
            {{ "RETRY" | translate }}
          </a>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="d-flex justify-content-between">
    <button mat-raised-button mat-dialog-close>
      {{ "CANCEL" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="form.invalid"
      (click)="savePassword()"
      cdkFocusInitial
    >
      {{ "VERIFY" | translate }}
    </button>
  </mat-dialog-actions>
</form>
